import React, { useState } from 'react'
import { Link } from 'gatsby'
import { HamburgerSpin } from 'react-animated-burgers'

import './navMenu.scss'
import pushEventDataLayer from '../../../utils/pushEventDataLayer'

const NavMenu = props => {
  const { isMobile } = props

  const [isActive, setIsActive] = useState(false)
  const [activeMenu, setActiveMenu] = useState(false)
  // Esto se realiza para activar una clase cuando este en esa seccion,
  // se hizo asi ya que Link, no permite con url que empieza con #
  const [active2, setActive2] = useState('')

  const toggleButton = () => {
    if (isMobile) {
      setIsActive(prevState => !prevState)
      setActiveMenu(prevState => !prevState)
    }
  }
  const Menu = () => {
    return (
      <nav className={`f-navMenu-container ${activeMenu && 'activeMenu'}`}>
        <section className="f-navMenu-container__content">
          <ul>
            <li>
              <Link
                to="/"
                className={active2 === 'banner' ? 'active2' : ''}
                onClick={() => {
                  toggleButton()
                  setActive2('banner')
                  pushEventDataLayer('Interacciones - Menú','Cur-v','Click', 'Cur-V')
                }}
              >
                Cur-V&#174;
              </Link>
            </li>
            <li>
              <Link
                to="#visual-360"
                className={active2 === 'visual360' ? 'active2' : ''}
                onClick={() => {
                  toggleButton()
                  setActive2('visual360')
                  pushEventDataLayer('Interacciones - Menú','Cur-v','Click', 'Visual 360')

                }}
              >
                Visual 360&#176;
              </Link>
            </li>
            <li>
              <Link
                to="#zona-virtual"
                className={active2 === 'zonaVirtual' ? 'active2 large' : ''}
                onClick={() => {
                  toggleButton()
                  setActive2('zonaVirtual')
                  pushEventDataLayer('Interacciones - Menú','Cur-v','Click', 'Zona Virtual')

                }}
              >
                Zona Virtual
              </Link>
            </li>
            <li>
              <Link
                to="#galeria"
                className={active2 === 'galeria' ? 'active2' : ''}
                onClick={() => {
                  toggleButton()
                  setActive2('galeria')
                  pushEventDataLayer('Interacciones - Menú','Cur-v','Click', 'Galería')

                }}
              >
                Galería
              </Link>
            </li>
            <li>
              <Link
                to="#mundoCurV"
                className={active2 === 'mundoCurV' ? 'active2 large' : ''}
                onClick={() => {
                  toggleButton()
                  setActive2('mundoCurV')
                  pushEventDataLayer('Interacciones - Menú','Cur-v','Click', 'Mundo Cur-V')
                }}
              >
                Mundo Cur-V&#174;
              </Link>
            </li>
          </ul>
        </section>
      </nav>
    )
  }

  return (
    <>
      {isMobile ? (
        <>
          <HamburgerSpin
            barColor="#fff"
            className="f-hamburBottom"
            {...{ isActive, toggleButton }}
          />
          {
            //menu mobile
            Menu()
          }
        </>
      ) : (
        Menu()
      )}
    </>
  )
}

export default NavMenu
